import type { FC } from 'react'
import { EmptyMessage, GrandSection } from 'ui'
import { Icon } from '@chakra-ui/react'
import { BiError } from 'react-icons/bi'

interface ServerErrorStdPageProps {
  text: string
}

const ServerErrorStdPage: FC<ServerErrorStdPageProps> = ({ text }) => {
  return (
    <GrandSection
      alignItems="center"
      display="flex"
      justifyContent="center"
      minH="50vh"
      sectionId="error">
      <Icon alignSelf="center" as={BiError} h="50px" w="50px" />
      <EmptyMessage fontSize="2xl" {...{ text }} />
    </GrandSection>
  )
}

export default ServerErrorStdPage
